export function isApplicationProfileDeactivated(application) {
	const profile = application?.applicant_profile
	return profile?.is_deactivated === true || Boolean(profile?.deactivated_at)
}

export function isProfileAvailabilityConflict(error) {
	return (
		error?.response?.status === 409 &&
		error?.response?.data?.code === 'applicant_profile_deactivated'
	)
}

export function beginAvailabilityRequest(state, commit) {
	const request = {
		id: Number(state.latestAvailabilityRequestId || 0) + 1,
		sessionGeneration: state.sessionGeneration
	}
	commit('setAvailabilityRequestId', request.id)
	return request
}
